import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { threadSuggestionsList_template } from "../components/templates/threadSuggestionsList_template";
import { header } from "./header";

declare const ko: any;
declare const page: any;

const THREAD_SUGGESTION_STATUS = {
    SUBMITTED: 1,
    APPROVED: 2,
    REJECTED: 3,
    PENDING_REVIEW: 4,
};

export class thread_suggestions extends vnModule_knockoutJS {
    protected idBrand: number;
    protected listTemplate: threadSuggestionsList_template;
    protected pagination: pagination_template;
    protected timer: number;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    protected ApiUrls: any = {
        referencesGet: `/api/thread-suggestions/references`,
        threadSuggestionsGet: `/api/thread-suggestions/get`,
        threadSuggestionsCount: `/api/thread-suggestions/count`,
        threadSuggestionsDelete: `/api/thread-suggestions/delete`,
        threadSuggestionsSave: `/api/thread-suggestions/save`,
        presetDelete: `/api/search_preset/delete`,
        presetFavoriteSave: `/api/search_preset/favorite/save`,
        presetGet: `/api/search_preset/get`,
        presetSave: `/api/search_preset/save`,
        userSuggestionsGet: '/api/search/website-users/',
    };

    protected getModuleName() {
        return "thread_suggestions";
    }

    public buildContent(): Array<Element> {
        this.idBrand = this.getVnAppZone().app.params.idBrand;
        this.listTemplate = new threadSuggestionsList_template("list", this.viewModel, this);
        this.template = this.listTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Thread Submissions");

        return [this.listTemplate.build()];
    }

    public fillPage(): void {
        this.listTemplate.buildDatePickerCalendar();
        this.getReferences();
    }

    protected getReferences() {
        this.XHRHdl = new XMLHttpRequestHandler(this.ApiUrls.referencesGet, [], this);
        this.XHRHdl.onReadyStateFunction = this.onGetReferences;
        this.XHRHdl.execute();
    }
    
    protected onGetReferences(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.listTemplate.setStatuses(responseParsed.statuses);
                obj.listTemplate.setArticleStatusFilter(responseParsed.articleStatuses);
                obj.listTemplate.setBrandFilter(responseParsed.brands);
                obj.listTemplate.setRejectionReasons(responseParsed.rejectionReasons);
                obj.getSearchPresets();
            });
        };
    }


    protected getData() {
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterList() {
        let requestModel = this.listTemplate.getViewModelForRequest();
        this.filterSimpleCancel();
        this.timer = new Date().getTime();
        this.listTemplate.setIdBrand(requestModel.filters.brand);
        this.loadingIn(this.listTemplate.builtTemplate.children.namedItem("list-results"));
        this.sendFilterCall(
            this.ApiUrls.threadSuggestionsGet,
            requestModel,
            this.onFilterList,
            XMLHttpRequestHandler_requestType.GET,
            "thread_suggestions",
            this.listTemplate.builtTemplate.children.namedItem("list-results"),
        );
    }

    protected onFilterList(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.listTemplate.setThreadSuggestions(responseParsed.data);
                obj.listTemplate.setResultInfo(
                    responseParsed.totalCount,
                    responseParsed.totalPage,
                    Math.round(((new Date().getTime() - obj.timer) / 1000) * 100) / 100,
                );
                obj.listTemplate.handleBrandColumnDisplay();
                obj.viewModel.list.pagination.itemCount(responseParsed.totalCount);
                obj.updateViewModelFromPath();
                obj.countAwaitingPublication();
            });
            obj.loadingOut(obj.listTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    protected countAwaitingPublication() {
        this.cancelRequest("countAwaitingPublication");
        let idBrand = this.listTemplate.getTemplateViewModel().filterBrand.selectedOption();
        let subViewModel = {filters: {status: [2], articleStatus: [0,1,2], brand: idBrand}};
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["countAwaitingPublication"] = new XMLHttpRequestHandler(this.ApiUrls.threadSuggestionsCount, usrReq_params, this);
        this.XHRHdls["countAwaitingPublication"].onReadyStateFunction = this.onCountAwaitingPublicationReturn;
        this.XHRHdls["countAwaitingPublication"].execute();
    }

    protected onCountAwaitingPublicationReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.listTemplate.setAwaitingPublicationCount(responseParsed.count);
            });
        };
    }

    protected filterByPresets(filters) {
        this.listTemplate.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterDateOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(idElement) {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected getMemoryViewModel() {
        let templateViewModel = this.listTemplate.getTemplateViewModel();
        delete templateViewModel.threadSuggestions;
        return templateViewModel;
    }

    protected getSearchPresets(): void {
        this.cancelRequest("getSearchPresets");
        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getSearchPresets"] = new XMLHttpRequestHandler(this.ApiUrls.presetGet, usrReq_params, this);
        this.XHRHdls["getSearchPresets"].onReadyStateFunction = this.onGetSearchPresets;
        this.XHRHdls["getSearchPresets"].execute();
    }

    protected onGetSearchPresets(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.setSearchPresets(response);
                obj.getData();
            });
        };
    }

    protected saveSearchPreset() {
        this.cancelRequest("saveSearchPreset");
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["saveSearchPreset"] = new XMLHttpRequestHandler(this.ApiUrls.presetSave, formReq_params, this);
        this.XHRHdls["saveSearchPreset"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["saveSearchPreset"].onReadyStateFunction = this.onSaveSearchPreset;
        this.XHRHdls["saveSearchPreset"].execute();
    }

    private onSaveSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    protected saveFavoriteSearchPreset(params: { presetId: number; searchPresetType: string }): void {
        this.cancelRequest("saveFavoriteSearchPreset");
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(params));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["saveFavoriteSearchPreset"] = new XMLHttpRequestHandler(
            this.ApiUrls.presetFavoriteSave,
            formReq_params,
            this,
        );
        this.XHRHdls["saveFavoriteSearchPreset"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["saveFavoriteSearchPreset"].onReadyStateFunction = this.onSearchPreset;
        this.XHRHdls["saveFavoriteSearchPreset"].execute();
    }

    private onSearchPreset(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    response.message,
                );
            });
        };
    }

    protected deleteSearchPreset(presetId: number): void {
        this.cancelRequest("deleteSearchPreset");
        let usrReq_url: string = `${this.ApiUrls.presetDelete}/${presetId}/`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdls["deleteSearchPreset"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["deleteSearchPreset"].onReadyStateFunction = this.onSearchPreset;
        this.XHRHdls["deleteSearchPreset"].execute();
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) this.XHRHdl.cancelAndReset();
    }

    protected cancelRequest(requestName) {
        if (this.XHRHdls !== undefined && this.XHRHdls[requestName] !== undefined) {
            this.XHRHdls[requestName].cancelAndReset();
        }
    }

    protected setDefaultStatusFilters() {
        // empty
    }

    protected filterMultipleSelectorOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange() {
        this.viewModel.list.pagination.itemsPerPage= this.viewModel.list.itemsPerPageFilter.selectedOption();
        this.viewModel.list.pagination.pageNumber(1);
        this.listTemplate.handleBrandColumnDisplay();
        this.filterList();
    }

    protected threadSuggestionsListReorder() {
        this.filterList();
    }
    protected getUsersSuggestion(keyword, idElement) {

        this.cancelRequest("getUsersSuggestion");

        let idBrand = this.listTemplate.getTemplateViewModel().filterBrand.selectedOption();
        let subViewModel = {list: {keyword: keyword}, idElement: idElement, idBrand: idBrand};
        let usrReq_url: string = `${this.ApiUrls.userSuggestionsGet}`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getUsersSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getUsersSuggestion'].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls['getUsersSuggestion'].execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data) {
                    obj.listTemplate.setUserFilterAutocomplete(responseParsed.data.users);
                }
            });
        };
    }

    public getListingPageById(idListingPage, idElement): void {
        this.cancelRequest("getListingPageById");
        let idBrand = this.listTemplate.getTemplateViewModel().filterBrand.selectedOption();
        let usrReq_url: string = `/api/brand/${idBrand}/config/listing-pages/get/${idListingPage}`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({idElement: idElement})]);
        let hdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        hdl.onReadyStateFunction = this.onGetListingPageByIdReturn;
        hdl.execute();
        this.XHRHdls['getListingPageById'] = hdl;
    }

    protected onGetListingPageByIdReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.setFilterListingPage(response.listingPage);
            });
        };
    }

    protected getListingPagesSuggestion(keyword, idElement): void {


        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let idBrand = this.listTemplate.getTemplateViewModel().filterBrand.selectedOption();
        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword, idArticleType: 16}, idElement: idElement};
        let usrReq_url: string = `/api/brand/${idBrand}/config/listing-pages/search/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetListingPagesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetListingPagesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.listingPages) {

                    obj.listTemplate.setFilterListingPagesAutoComplete(response.data.listingPages, response.data.idElement);
                }
            });
        }
    }

    protected editArticle(data = undefined) {
        data = data || this.listTemplate.getViewModelForSave().threadToEdit;
        let brandId;
        try {
            brandId = data.accessPoint.brands[0].id;
        }
        catch (e) {
            alert("Error: " + e);
            this.getVnAppZone().notification = new vn_app_zone_notification(
                vn_app_zone_notification.TYPE_ERROR,
                "No brand found for this thread suggestion"
            );
        }
        if (!brandId) {
            return;
        }
        window.open(`/brand/${brandId}/articles/view/${data.idArticle}`, "_blank");
    }

    protected createArticle(data = undefined) {
        let model = this.listTemplate.getViewModelForSave();
        data = data || model.threadToEdit;
        let brandId;

        try {
            brandId = data.accessPoint.brands[0].id;
        }
        catch (e) {
            alert("Error: " + e);
            this.getVnAppZone().notification = new vn_app_zone_notification(
                vn_app_zone_notification.TYPE_ERROR,
                "No brand found for this thread suggestion"
            );
        }
        if (!brandId) {
            return;
        }

        if (data.articleId) {
            window.open(`/brand/${brandId}/articles/view/${data.articleId}`, "_blank");
        } else {
            window.open(`/brand/${brandId}/articles/add?idThreadSuggestion=${data.id}`, "_blank");
        }
    }

    protected viewWebsiteUser(data = undefined) {
        data = data || this.listTemplate.getViewModelForSave().threadToEdit;
        let id = data.rawData.accessPointUser.idWebsiteUser;
        window.open(`/website-users/edit/${id}`, "_blank");
    }

    public save() {
        let data = this.listTemplate.getViewModelForSave();
        let validationList = this.listTemplate.validationsListTemplate;
        validationList.clearMessages();
        
        if (+data.idEditStatus() ===  THREAD_SUGGESTION_STATUS.REJECTED) {
            if (!+data.idRejectionReason()) {
                validationList.setMessages([{
                    field: 'Rejection Reason',
                    label: 'Rejection Reason',
                    messages: ['Missing reason.']
                }]);
                return;
            }

            if (+data.idRejectionReason() == 1 && !data.rejectionMessage()) {
                validationList.setMessages([{
                    field: 'Rejection Reason',
                    label: 'Rejection Reason',
                    messages: ['Missing custom reason message.']
                }]);
                return;
            }
        }


        let usrReq_url: string = `${this.ApiUrls.threadSuggestionsSave}`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(data)]);
        let XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSave.bind(this);
        XHRHdl.execute();
    }

    protected onSave(req, obj) {
        return function () {
             if (req.request.status == 500) {
                let validationList = obj.listTemplate.validationsListTemplate;
                validationList.clearMessages();
                try {
                    let message = JSON.parse(req.request.response).message;
                    validationList.setMessages([{messages:[message], label: "Error", field: "-500"}]);
                } catch (e) {
                    validationList.addMessageToValidationList([{
                        label: "500",
                        field: "500",
                        messages: ['An error occurs during the save request']
                    }]);
                }
            } else {
                obj.manageResponse(req, obj, function () {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(
                        vn_app_zone_notification.TYPE_SUCCESS,
                        "Thread suggestion saved successfully!",
                    );

                    let model:any = obj.listTemplate.getViewModelForSave();
                    let threadSuggestion = model.threadToEdit;

                    if (model.createArticleUponApproval() 
                        && model.idEditStatus() == THREAD_SUGGESTION_STATUS.APPROVED  
                        && threadSuggestion.idStatus != THREAD_SUGGESTION_STATUS.APPROVED) {
                        obj.createArticle(model.threadToEdit);
                    }

                    obj.listTemplate.onClickHidePopUp();
                    obj.filterList();
                });
            }
        };
    }
    protected delete(data) {
        let usrReq_url: string = `${this.ApiUrls.threadSuggestionsDelete}`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(data)]);
        let XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onDelete.bind(this);
        XHRHdl.execute();
    }

    protected onDelete(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    "Thread suggestion deleted successfully!",
                );
                obj.filterList();
            });
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/thread_suggestions.ts